





































import { Component, Prop, Vue } from "vue-property-decorator";

import { CookieHelper } from "@/helper/cookieHelper";
import { DateHelper } from "@/helper/dateHelper";
import { CloudHelper } from "@/helper/cloudHelper";
import { ResourceHelper } from "@/helper/resourceHelper";
import { Const } from "@/const";

import Close from "../resources/close.vue";

@Component({
  components: {
      Close
  }
})

export default class InputMail extends Vue {
    @Prop() private device! : string;
    @Prop() private isError! : boolean;
    @Prop() private errorMessages! : Array<{index : number, message: string}>;

    mail = "";
    isCanSubmit = false;

    private mounted(){
        (this.$refs.mail as HTMLElement).focus();
    }

    private onDoCommand(command : string, param : any){
        this.$emit("doCommand", command, param);
    }

    private setCanSubmit(){
        this.isCanSubmit = true;
    }

    private keyupEnter(element){
        if(!this.isCanSubmit){ return; }
        this.isCanSubmit = false;
        (this.$refs[element] as HTMLElement).blur();
        if(this.mail == ""){ return; }
        this.send();
    }

    private returnPage(){
        this.onDoCommand("returnPage", null);
    }

    private send(){
        var param = {
            mail : this.mail
        };
        this.onDoCommand("sendMail", param);
    }

    private get userConfigBackgroundColor(){
        var style = {
            background : this.$store.getters.userConfigColors.backgroundColor
        };
        return style;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigButtonColor(){
        var style = {
            backgroundColor: this.userConfigColor
        };
        return style;
    }
    private get userConfigBorderColor(){
        var style = {
            border: "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigUnderLineColor(){
        var style = {
            borderBottom: "solid 1px " + this.userConfigColor
        };
        return style;
    }
    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
